import { usePreferences } from "../../contexts/PreferencesContext";
import React from "react";

const normalize = (value) => String(value ?? "").trim().toLowerCase();

export const getApprovalStatus = (value) => {
  const status = normalize(value || "pendente");
  if (status === "aprovado") return { labelKey: "status_approved", tone: "success" };
  if (status === "recusado" || status === "reprovado") return { labelKey: "status_rejected", tone: "danger" };
  return { labelKey: "status_pending", tone: "warning" };
};

export const getQuestionStatus = (value) => {
  const status = normalize(value);
  if (status === "a" || status === "anulada") return { labelKey: "status_annulled", tone: "danger" };
  return { labelKey: "status_valid", tone: "success" };
};

export const getAttendanceStatus = (value) => {
  const status = normalize(value);
  if (status === "presente") return { labelKey: "status_present", tone: "success" };
  return { labelKey: "status_absent", tone: "danger" };
};

export const getResultStatus = (value) => {
  const status = normalize(value);
  if (status === "corrigida") return { labelKey: "status_corrected", tone: "success" };
  if (status === "nao-corrigida" || status === "não-corrigida") return { labelKey: "status_not_corrected", tone: "warning" };
  if (status === "f" || status === "finalizado") return { labelKey: "status_finished", tone: "success" };
  if (status === "ausente") return { labelKey: "status_absent", tone: "danger" };
  if (status === "não iniciado" || status === "nao iniciado") return { labelKey: "status_not_started", tone: "neutral" };
  return { labelKey: "status_not_finished", tone: "warning" };
};

export const getReliabilityStatus = (value) => {
  const score = Number(value);
  if (Number.isNaN(score)) return { label: "-", tone: "neutral" };
  if (score <= 100) return { label: value, tone: "success" };
  if (score <= 1000) return { label: value, tone: "warning" };
  return { label: value, tone: "danger" };
};

export const getAnswerStatus = (answered) =>
answered ? { labelKey: "status_answered", tone: "success" } : { labelKey: "status_not_answered", tone: "warning" };

export const getResourceDecisionStatus = (value) => {
  const status = normalize(value);
  if (status === "deferido") return { labelKey: "status_granted", tone: "success" };
  return { labelKey: "status_denied", tone: "danger" };
};

const StatusBadge = ({ label, labelKey, tone = "neutral", className = "" }) => {
  const { t } = usePreferences();

  return (
    <span className={`status-badge-modern status-badge-${tone} ${className}`.trim()}>
      {labelKey ? t(labelKey) : label}
    </span>
  );
};


export default StatusBadge;
